import { Component } from '@angular/core';
import { BlockScreenService } from '@shared/services/block-screen.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(public blockScreenService: BlockScreenService) {
    const version = require('../../package.json').version;
    console.log(`App Version: ${version}`)
  }
}
